// extracted by mini-css-extract-plugin
module.exports = {"mainModalPanel":"AddInvoicePopup_AX_mainModalPanel__I+Av-"};